import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=d53a3b50&scoped=true&"
import script from "./Sector.vue?vue&type=script&lang=js&"
export * from "./Sector.vue?vue&type=script&lang=js&"
import style0 from "./Sector.vue?vue&type=style&index=0&id=d53a3b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53a3b50",
  null
  
)

export default component.exports